<template>
  <div class="l-main">
    <div class="l-main__header">
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-100">
          <ul class="c-breadcrumbs">
            <li class="c-breadcrumbs__item">
              <a
                class="c-breadcrumbs__link c-breadcrumbs__home c-breadcrumbs__home--disabled"
              >
                <md-icon>home</md-icon>
                <span>Home</span>
              </a>
            </li>
            <li class="c-breadcrumbs__item--separator">
              /
            </li>
            <li class="c-breadcrumbs__item">
              <a class="c-breadcrumbs__link c-breadcrumbs--disabled">VIP CMS</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="l-main__ctn u-box">
      <md-tabs v-if="!hasActiveChildRoute" class="c-tabs c-tabs--vip" :md-active-tab.sync="activeTab" @md-changed="onTabChanged">
        <md-tab id="tab-settings" md-label="Settings">
          <vip-settings-component />
        </md-tab>
        <md-tab id="tab-history-logs" md-label="History Logs">
          <vip-history-logs-component ref="historyLogsComponent" />
        </md-tab>
      </md-tabs>
      <router-view v-else />
    </div>
  </div>
</template>

<script>
import {PERMISSION_NAMES} from "@/const/online-permissions";
import VipSettingsComponent from './sub-pages/vip-settings';
import VipHistoryLogsComponent from './sub-pages/vip-history-logs';
import {onlinePermissionsMixin} from "@/mixins/onlinePermissionsMixin";

export default {
  name: "VipComponent",

  components: {
    VipSettingsComponent,
    VipHistoryLogsComponent,
  },

  mixins: [onlinePermissionsMixin],

  data() {
    return {
      permissionName: `${PERMISSION_NAMES.VIP.key}.${PERMISSION_NAMES.VIP.key}`,
      activeTab: 'tab-settings',
    }
  },

  computed: {
    hasActiveChildRoute() {
      return this.$route.matched.length > 2;
    }
  },

  methods: {
    onTabChanged(tabId) {
      if (tabId === 'tab-history-logs' && this.$refs.historyLogsComponent) {
        this.$refs.historyLogsComponent.loadHistoryLogs();
      } else if (tabId === 'tab-settings' && this.$refs.historyLogsComponent) {
        this.$refs.historyLogsComponent.resetHistoryLogs();
      }
    },
  },
};
</script>

<style scoped>
  .c-tabs--vip ::v-deep .md-tabs-navigation {
    position: sticky;
    top: 0;
    z-index: 10;
  }
</style>
